import React from "react"
import {observer} from "mobx-react-lite"
import Modal from "../../components/DiscoveryModal"
import Button from "@material-ui/core/Button"
import {UseStores} from "../../hooks/UseStores"
import BehavioralAudienceAffinity from "../../components/BehavioralAudienceAffinity"
import "./InsightModalPage.scss"
import MonthOverMonthFootTraffic from "../../components/MonthOverMonthFootTraffic"
import TopCrossoverBrands from "../../components/TopCrossoverBrands"
import MonthlyVisits from "../../components/MonthlyVisits"
import {makeStyles} from "@material-ui/core/styles"
import "./InsightModalPage.scss"

const useStyles = makeStyles((theme) => ({
  buttonGreen: theme.overrides.buttonGreen,
  buttonTertiaryGreen: theme.overrides.buttonTertiaryGreen,
}))
const InsightModalPage = ({open, handleInsightPopup, handleShowInsights, item}) => {
  const {gtMapStore} = UseStores()
  let locations = gtMapStore.locations
  const breadcrumbs = (() => {
    if (locations)
      return (
        <ul>
          {locations.map((location) => {
            return (
              <li key={location.geoType}>
                <p>{location.geoName}</p>
                <span className="chevron-right"></span>
              </li>
            )
          })}
        </ul>
      )
  })()

  const modalClassName = "insight_modal"
  const handleClickOpen = () => {
    handleInsightPopup(true)
  }
  const handleClose = () => {
    handleInsightPopup(false)
  }

  const handleMore = () => {
    handleShowInsights()
    handleInsightPopup(false)
  }
  const classes = useStyles()
  const modalTitle = (() => {
    return (
      <React.Fragment className="abcd">
        <div>{item.name} Insight Summary</div>
        <div className="breadcrumbs">{breadcrumbs}</div>
      </React.Fragment>
    )
  })()

  const modalBody = (() => {
    return (
      <React.Fragment>
        <div className="wrapperContent">
          <div className="content">
            <MonthlyVisits />
          </div>
          <div className="content">
            <MonthOverMonthFootTraffic />
          </div>
          <div className="content">
            <BehavioralAudienceAffinity />
          </div>
          <div className="content">
            <TopCrossoverBrands />
          </div>
        </div>
      </React.Fragment>
    )
  })()

  const modalActions = (() => {
    return (
      <React.Fragment>
        <Button
          autoFocus
          onClick={handleMore}
          color="primary"
          className={classes.buttonGreen}
        >
          Check More
        </Button>
        <Button
          autoFocus
          onClick={handleClose}
          color="primary"
          className={classes.buttonTertiaryGreen}
        >
          Cancel
        </Button>
      </React.Fragment>
    )
  })()

  return (
    <Modal
      {...{
        open,
        handleClickOpen,
        handleClose,
        modalTitle,
        modalBody,
        modalActions,
        modalClassName,
      }}
    />
  )
}

export default observer(InsightModalPage)
